// extracted by mini-css-extract-plugin
export default {"root":"app-footer_root__QcmUx","auth":"app-footer_auth__kvWcZ","logo":"app-footer_logo__8T+ZS","links":"app-footer_links__K7OvY","author":"app-footer_author__Dwf4i"};